import React from 'react';
import { motion } from 'framer-motion';
import './styles/project-card.css';

export default function projectItem({ title, subtitle, tags = [] }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      variants={{
        visible: { opacity: 1, scale: 1 },
        hidden: { opacity: 0, scale: 0.8 },
      }}
      className="card-container"
    >
      <div className="card-project">
        {/* Number is drawn by a CSS counter — see project-card.css */}
        <div className="card-project__index" aria-hidden="true" />

        <div className="card-project__body">
          <h3 className="card-project__title">{title}</h3>
          <p className="card-project__subtitle">{subtitle}</p>

          {tags.length > 0 && (
            <div className="card-project__tags">
              {tags.map(tag => (
                <span className="card-project__tag" key={tag}>
                  {tag}
                </span>
              ))}
            </div>
          )}

          {/* A real button so the card stays reachable by keyboard — the click
              handler lives on the wrapper in each project component */}
          <button type="button" className="card-project__action">
            View details
            <span className="card-project__arrow" aria-hidden="true">
              →
            </span>
          </button>
        </div>
      </div>
    </motion.div>
  );
}
